"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var articleApi = _interopRequireWildcard(require("@/api/article.js"));
var storeApi = _interopRequireWildcard(require("@/api/product.js"));
var _info = _interopRequireDefault(require("./info"));
var _edit = _interopRequireDefault(require("./edit"));
var selfUtil = _interopRequireWildcard(require("@/utils/ZBKJIutil.js"));
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  // name: "list"
  components: {
    info: _info.default,
    edit: _edit.default
  },
  props: {
    biztype: {
      // 类型，1 产品分类，2 文章分类
      type: Object,
      default: {
        value: -1
      },
      validator: function validator(obj) {
        return obj.value > 0;
      }
    },
    pid: {
      type: Number,
      default: 0,
      validator: function validator(value) {
        return value >= 0;
      }
    },
    selectModel: {
      // 是否选择模式
      type: Boolean,
      default: false
    },
    selectModelKeys: {
      type: Array
    },
    rowSelect: {}
  },
  data: function data() {
    return {
      selectModelKeysNew: this.selectModelKeys,
      loading: false,
      constants: this.$constants,
      tableKey: 0,
      treeProps: {
        label: 'name',
        children: 'child'
        // expandTrigger: 'hover',
        // checkStrictly: false,
        // emitPath: false
      },
      // treeCheckedKeys:[],// 选择模式下的属性结构默认选中
      multipleSelection: [],
      editDialogConfig: {
        visible: false,
        isCreate: 0,
        // 0=创建，1=编辑
        prent: {},
        // 父级对象
        data: {},
        biztype: this.biztype // 统一主业务中的目录类型
      },
      dataList: [],
      tableData: [],
      listPram: {
        pid: this.pid,
        type: this.biztype.value,
        status: -1,
        name: '',
        page: this.$constants.page.page,
        limit: this.$constants.page.limit[0]
      },
      viewInfoConfig: {
        data: null,
        visible: false
      },
      defaultImg: require('@/assets/imgs/moren.jpg')
    };
  },
  mounted: function mounted() {
    if (this.biztype.value === 2) {
      if ((0, _permission.checkPermi)(['platform:article:category:list'])) this.handlerGetList();
    } else {
      if ((0, _permission.checkPermi)(['platform:product:page:list'])) this.handlerGetTreeList();
    }
  },
  methods: {
    checkPermi: _permission.checkPermi,
    //权限控制
    onchangeIsShow: function onchangeIsShow(row) {
      var _this = this;
      this.$modal.loading('处理中，请稍候...');
      if (this.biztype.value === 2) {
        articleApi.articleCategorySwitchApi(row.id).then(function () {
          _this.$message.success('修改成功');
          localStorage.clear('articleClass');
          _this.handlerGetList();
          _this.tableKey++;
        }).catch(function () {
          row.status = !row.status;
        }).finally(function () {
          _this.$modal.closeLoading();
        });
      } else {
        storeApi.productCategoryShowApi(row.id).then(function () {
          _this.$message.success('修改成功');
          _this.$store.commit('product/SET_AdminProductClassify', []);
          _this.handlerGetTreeList();
          _this.initTableDataRoot();
          _this.tableKey++;
        }).catch(function () {
          row.isShow = !row.isShow;
        }).finally(function () {
          _this.$modal.closeLoading();
        });
      }
    },
    handleEditMenu: function handleEditMenu(rowData) {
      this.editDialogConfig.isCreate = 1;
      this.editDialogConfig.data = rowData;
      this.editDialogConfig.prent = rowData;
      this.editDialogConfig.visible = true;
    },
    handleAddMenu: function handleAddMenu(rowData) {
      this.editDialogConfig.isCreate = 0;
      this.editDialogConfig.prent = rowData;
      this.editDialogConfig.data = {};
      this.editDialogConfig.biztype = this.biztype;
      this.editDialogConfig.visible = true;
    },
    getCurrentNode: function getCurrentNode(data) {
      var node = this.$refs.tree.getNode(data);
      this.childNodes(node);
      // this.parentNodes(node);
      //是否编辑的表示
      // this.ruleForm.isEditorFlag = true;
      //编辑时候使用
      this.$emit('rulesSelect', this.$refs.tree.getCheckedKeys());
      // this.selectModelKeys = this.$refs.tree.getCheckedKeys();
      //无论编辑和新增点击了就传到后台这个值
      // this.$emit('rulesSelect', this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys()));
      // this.ruleForm.menuIdsisEditor = this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys());
    },
    //具体方法可以看element官网api
    childNodes: function childNodes(node) {
      var len = node.childNodes.length;
      for (var i = 0; i < len; i++) {
        node.childNodes[i].checked = node.checked;
        this.childNodes(node.childNodes[i]);
      }
    },
    parentNodes: function parentNodes(node) {
      if (node.parent) {
        for (var key in node) {
          if (key == 'parent') {
            node[key].checked = true;
            this.parentNodes(node[key]);
          }
        }
      }
    },
    handleDelete: function handleDelete(rowData) {
      var _this2 = this;
      this.$modalSure(this.biztype.value === 2 ? '删除当前数据?' : '删除品类吗？该品类优惠券将同步删除。').then(function () {
        if (_this2.biztype.value === 2) {
          articleApi.articleCategoryDelApi(rowData).then(function (data) {
            _this2.handlerGetList();
            localStorage.clear('articleClass');
            _this2.$message.success('删除成功');
          });
        } else {
          storeApi.productCategoryDeleteApi(rowData.id).then(function (data) {
            _this2.handlerGetTreeList();
            _this2.$message.success('删除成功');
          });
        }
      });
    },
    handlerGetList: function handlerGetList() {
      var _this3 = this;
      this.loading = true;
      articleApi.articleCategoryListApi().then(function (data) {
        _this3.dataList = data;
        var list = data.filter(function (item) {
          return item.status;
        });
        localStorage.setItem('articleClass', JSON.stringify(list));
      }).finally(function () {
        _this3.loading = false;
      });
    },
    handlerGetTreeList: function handlerGetTreeList() {
      var _this4 = this;
      this.loading = true;
      storeApi.productCategoryListApi().then(function (res) {
        var obj = {},
          dataList = [];
        res.forEach(function (item) {
          obj = item;
          obj.parentId = item.pid;
          obj.children = [];
          dataList.push(obj);
        });
        _this4.dataList = _this4.handleTree(dataList, 'menuId');
        // 初始化首层懒加载数据（不影响对外 dataList）
        _this4.initTableDataRoot();
      }).catch(function () {}).finally(function () {
        _this4.loading = false;
      });
    },
    // 初始化表格首层数据：本地懒加载根节点（不调接口）
    initTableDataRoot: function initTableDataRoot() {
      if (this.biztype.value !== 1) {
        this.tableData = this.dataList;
        return;
      }
      var roots = Array.isArray(this.dataList) ? this.dataList.filter(function (n) {
        return !n.parentId || n.parentId === 0;
      }) : [];
      this.tableData = roots.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          children: [],
          hasChildren: !!(item.children && item.children.length)
        });
      });
    },
    // 懒加载子节点：展开时从 dataList 本地树取 children
    loadChildrenForTable: function loadChildrenForTable(tree, treeNode, resolve) {
      if (this.biztype.value !== 1) return resolve([]);
      var fullNode = this.findNodeFromDataList(tree.id);
      var children = fullNode && fullNode.children ? fullNode.children : [];
      var rows = children.map(function (c) {
        return _objectSpread(_objectSpread({}, c), {}, {
          children: [],
          hasChildren: !!(c.children && c.children.length)
        });
      });
      resolve(rows);
    },
    // 在 dataList 树中查找指定 id 的节点
    findNodeFromDataList: function findNodeFromDataList(id) {
      var stack = Array.isArray(this.dataList) ? _toConsumableArray(this.dataList) : [];
      while (stack.length) {
        var node = stack.pop();
        if (node.id === id) return node;
        if (node.children && node.children.length) stack.push.apply(stack, _toConsumableArray(node.children));
      }
      return null;
    },
    handlerGetInfo: function handlerGetInfo(id) {
      this.viewInfoConfig.data = id;
      this.viewInfoConfig.visible = true;
    },
    handleNodeClick: function handleNodeClick(data) {},
    handleAddArrt: function handleAddArrt(treeData) {
      var _result = selfUtil.addTreeListLabel(treeData);
      return _result;
    },
    hideEditDialog: function hideEditDialog() {
      var _this5 = this;
      setTimeout(function () {
        _this5.editDialogConfig.prent = {};
        _this5.editDialogConfig.type = 0;
        _this5.editDialogConfig.visible = false;
        if (_this5.biztype.value === 2) {
          _this5.handlerGetList();
        } else {
          _this5.handlerGetTreeList();
        }
      }, 200);
    },
    handleSelectionChange: function handleSelectionChange(d1, _ref) {
      var checkedNodes = _ref.checkedNodes,
        checkedKeys = _ref.checkedKeys,
        halfCheckedNodes = _ref.halfCheckedNodes,
        halfCheckedKeys = _ref.halfCheckedKeys;
      // this.multipleSelection =  checkedKeys.concat(halfCheckedKeys)
      this.multipleSelection = checkedKeys;
      this.$emit('rulesSelect', this.multipleSelection);
    }
  }
};